(function () {
    'use strict';

    var STAR_LABEL_RE = /^(\d+(?:[.,]\d+)?)\s+stars?$/i;

    function frenchStarLabel(value) {
    var normalized = value.replace(',', '.');
    var num = parseFloat(normalized);
    var suffix = (num <= 1) ? 'étoile' : 'étoiles';
    return value + ' ' + suffix;
    }

    function translateLabel(el) {
    var label = el.getAttribute('aria-label');
    if (!label) return;
    var match = label.match(STAR_LABEL_RE);
    if (match) {
    el.setAttribute('aria-label', frenchStarLabel(match[1]));
    }
    }

    function isJdgmElement(el) {
    return !!(el && el.classList && Array.prototype.some.call(el.classList, function (c) {
    return c.indexOf('jdgm-') === 0;
    }));
    }

    function translateAll(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    if (root.nodeType === 1 && isJdgmElement(root) && root.hasAttribute('aria-label')) {
    translateLabel(root);
    }
    var els = root.querySelectorAll('[class*="jdgm-"][aria-label]');
    for (var i = 0; i < els.length; i++) {
    translateLabel(els[i]);
    }
    }

    function init() {
    translateAll(document);

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
    var mutation = mutations[i];
    if (mutation.type === 'childList') {
    mutation.addedNodes.forEach(function (node) {
    if (node.nodeType === 1) {
    translateAll(node);
    }
    });
    } else if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
    var target = mutation.target;
    if (isJdgmElement(target)) {
    translateLabel(target);
    }
    }
    }
    });

    observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label']
    });
    }

    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    } else {
    init();
    }
    })();